<div id="profile-dropdown" data-testid="profile-dropdown-container" [ngClass]="{'dropdown-visible': dropdownVisible()}">
  @if (!infoSubMenuVisible()) {
    @if (!isAuthorized()) {
      <div class="dropdown-el" data-testid="profile-dropdown-login-btn" (click)="login()">
        <img class="dropdown-el-icon login-icon" [src]="loginIconPath()" />
        <h5 class="dropdown-el-text">{{ languageService.languageJSON.Global_Login }}</h5>
      </div>
    }
    @if (isAuthorized()) {
      <div class="dropdown-el" data-testid="profile-dropdown-edit-account-btn" (click)="openAccountDialog()">
        <img class="dropdown-el-icon edit-icon" [src]="editIconPath()" />
        <h5 class="dropdown-el-text">{{ languageService.languageJSON.Global_EditAccount }}</h5>
      </div>
    }
    <div class="dropdown-el" data-testid="profile-dropdown-subscriptions-btn" (click)="openSubscriptionsDialog()">
      <img class="dropdown-el-icon subscription-icon"
        [src]="subscriptionsIconPath()" />
      <h5 class="dropdown-el-text">{{ languageService.languageJSON.Global_Subscriptions }}</h5>
    </div>
    @if (isAuthorized()) {
      <div class="dropdown-el" data-testid="profile-dropdown-history-btn" [ngClass]="{'inactive': loadingMap}" (click)="openHistoryDialog();">
        <img class="dropdown-el-icon history-icon" [src]="historyIconPath()" />
        <h5 class="dropdown-el-text">{{ languageService.languageJSON.Global_History }}</h5>
      </div>
    }
    <div class="dropdown-el" data-testid="profile-dropdown-settings-btn" (click)="openSettings()">
      <img class="dropdown-el-icon settings-icon" [src]="settingsIconPath()" />
      <h5 class="dropdown-el-text">{{ languageService.languageJSON.Global_Settings }}</h5>
    </div>
    <div class="dropdown-el info-row" data-testid="profile-dropdown-info-btn" (click)="toggleInfoSubMenu()">
      <img class="dropdown-el-icon info-icon" [src]="infoIconPath()" />
      <h5 class="dropdown-el-text">{{ languageService.languageJSON.Global_Info }}</h5>
      <img class="dropdown-el-arrow" [src]="openArrowIconPath()" />
    </div>
    @if (isAuthorized()) {
      <div class="dropdown-el" data-testid="profile-dropdown-logout-btn" (click)="logout()">
        <img class="dropdown-el-icon logout-icon" [src]="logoutIconPath()" />
        <h5 class="dropdown-el-text">{{ languageService.languageJSON.Global_Logout }}</h5>
      </div>
    }
  }
  @if (infoSubMenuVisible()) {
    <div class="info-submenu-header" data-testid="profile-dropdown-info-back-btn" (click)="closeInfoSubMenu()">
      <img class="info-submenu-back" [src]="backMenuIconPath()" />
      <h5 class="info-submenu-title">{{ languageService.languageJSON.Global_Info }}</h5>
    </div>
    <div class="dropdown-el" data-testid="profile-dropdown-info-welcome-btn" (click)="openInfoTab('welcome')">
      <img class="dropdown-el-icon ev-logo" [src]="welcomeIconPath()" />
      <h5 class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_Welcome }}</h5>
    </div>
    <div class="dropdown-el" data-testid="profile-dropdown-info-feedback-btn" (click)="openInfoTab('feedback')">
      <img class="dropdown-el-icon" [src]="feedbackIconPath()" />
      <h5 class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_Feedback }}</h5>
    </div>
    <div class="dropdown-el" data-testid="profile-dropdown-info-tutorial-btn" (click)="startTutorial()"
      [class.inactive]="!tutorialService.canStart()">
      <img class="dropdown-el-icon" [src]="tutorialIconPath()" />
      <h5 class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_Tutorial }}</h5>
    </div>
    <div class="dropdown-el" data-testid="profile-dropdown-info-privacy-btn" (click)="openInfoTab('privacy')">
      <img class="dropdown-el-icon" [src]="privacyPolicyIconPath()" />
      <h5 class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_PrivacyPolicy }}</h5>
    </div>
    <div class="dropdown-el" data-testid="profile-dropdown-info-legal-btn" (click)="openInfoTab('legal')">
      <img class="dropdown-el-icon" [src]="legalInfoIconPath()" />
      <h5 class="dropdown-el-text">{{ languageService.languageJSON.TabbedInfoDialog_Legal }}</h5>
    </div>
  }
</div>